import React from 'react';
import queryString from 'query-string'
import { strainService, straincollectionService } from '../../services';
import filters from '../../config/filters'
import sorts from '../../config/sorts'
import dynamic from 'next/dynamic';
import { serverLocationDetector } from '../../utils/locationDetector';
// import Layout from '../components/_App/Layout';
const Layout = dynamic(() => import('../../components/_App/Layout'))
const Strains = dynamic(() => import('../../templates/Strains'))

export default function Strain(props) {

    return (
        <Layout
            isAppleMobile = {props.isAppleMobile}
            
            seo={{
                description: `Find your strain by discovering the effects each has to offer. Cannabis has thousands of different strains that are classified into three types: Sativa, Indica, and Hybrid.${props.page ? ' Page '+props.page+' - ' : ''}`,
                image:'/static/icons/favicon.png',
                title: `${props.page ? 'Page '+props.page+' - ' : ''}Explore Cannabis Strains | Weedzly`,
                url:'https://weedzly.com/strains'
            }}
        >
            <Strains
                items={props.data} 
                filters={filters.strainsPage}
                sorts={sorts.StrainsPage} 
                link={`/strains`}
                linkAs={`/strains`}
                disableInnerSearch={false}
                sectionTitle={'STRAINS'}
                collections={props.collections}
            />
        </Layout>
    )
}

export async function getServerSideProps(context){
    let isAppleMobile = (context.req
        ? context.req.headers['user-agent']
        : navigator.userAgent).match(
          /iPhone|iPad|iPod/i
        )

    await serverLocationDetector(context)

    let _query = Object.assign({
        page: 1,
        size: 20
    }, context.query)

    const [ data, collections ] = await Promise.all([
        await strainService.getPaginated(`?${queryString.stringify(_query)}`),
        await straincollectionService.getAll()
    ])

    return {
        props: {
            isAppleMobile,
            data, 
            page: (context.query && context.query.page) ? context.query.page : null,
            collections,
            contextQuery: context.query
        }
    } 
}


